<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-card class="box">
            <v-toolbar dense flat dark class="toolbar">
                <v-toolbar-title>Inventory</v-toolbar-title>
                <v-spacer> </v-spacer>
                <v-btn class="button" @click="add_new = true">
                    Add Inventory
                </v-btn>
            </v-toolbar>
            <v-row v-if="add_new" class="box" justify="center" dense>
                <v-col cols="12" sm="12" md="12" v-if="add_new">
                    <v-toolbar dense flat dark class="toolbar">
                        <v-btn icon dark @click="add_new=false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                        <v-toolbar-title>Add New Inventory</v-toolbar-title>
                        <v-spacer> </v-spacer>
                    </v-toolbar>
                </v-col>
                <v-col cols="12" sm="4" md="4">
                    <p><v-icon color="error">*</v-icon><b>Material Name</b></p>
                    <v-autocomplete
                        color="#0F2027"
                        @change="getPart_Specification()"
                        dense
                        rounded
                        required
                        v-model="mtype"
                        :items="material_type_list"
                        item-text="name"
                        return-object
                        label="Material Name"
                        outlined
                        persistent-hint
                        hint="Please Select Material Name"
                    />
                </v-col>
                <v-col cols="12" sm="4" md="4" v-if="mtype">
                    <p><b>Material Set</b></p>
                    <v-text-field type="text" filled label="Material Set" readonly rounded outlined dense v-model="mtype.invmaterialset"></v-text-field>
                </v-col>
                <v-col cols="12" sm="4" md="4" v-if="mtype">
                    <p><b>Material Type</b></p>
                    <v-text-field type="text" filled label="Material Type" readonly rounded outlined dense v-model="mtype.invmaterialtype"></v-text-field>
                </v-col>
                <v-col cols="12" sm="4" md="4" v-if="mtype">
                    <p><b>Material Category</b></p>
                    <v-text-field type="text" filled label="Material Category" readonly rounded outlined dense v-model="mtype.invmaterialcategory"></v-text-field>
                </v-col>
                <v-col cols="12" sm="4" md="4" v-if="mtype">
                    <p><v-icon color="error">*</v-icon><b>Material Specification</b></p>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="mspec"
                        :items="material_specification"
                        item-text="specification"
                        item-value="id"
                        label="Material Specification"
                        outlined
                        persistent-hint
                        hint="Please Select Material Specification"
                    />
                </v-col>

                <v-col cols="12" sm="4" md="4">
                    <p><v-icon color="error">*</v-icon><b>Invoice / Bill Number</b></p>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="invoice"
                        :items="invoice_list"
                        item-text="invoice_number"
                        return-object
                        label="Invoice / Bill Number"
                        outlined
                        persistent-hint
                        hint="Please Select Invoice / Bill Number"
                    />
                </v-col>

                <v-col cols="12" sm="4" md="4" v-if="invoice">
                    <p><b>Invoice Bill / Date</b></p>
                    <v-text-field type="text" filled label="Invoice Bill / Date" readonly rounded outlined dense v-model="invoice.invoice_date"></v-text-field>
                </v-col>
                <v-col cols="12" sm="4" md="4" v-if="invoice">
                    <p><b>Vendor / Supplier Name</b></p>
                    <v-text-field type="text" filled label="Vendor / Supplier Name" readonly rounded outlined dense v-model="invoice.invvendor"></v-text-field>
                </v-col>

                <v-col cols="12" sm="4" md="4">
                    <p><v-icon color="error">*</v-icon><b>Financial Year</b></p>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="ay" :items="ay_list" item-text="ay" item-value="id" label="Financial Year" outlined persistent-hint hint="Please Select Financial Year" />
                </v-col>
                <v-col cols="12" sm="4" md="4">
                    <p><v-icon color="error">*</v-icon><b>Oragnization</b></p>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="org" :items="org_list" item-text="org_name" item-value="org_id" label="Oragnization" outlined persistent-hint hint="Please Select Oragnization" />
                </v-col>
                <v-col cols="12" sm="4" md="4">
                    <p><v-icon color="error">*</v-icon><b>Room No.</b></p>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="room" :items="room_list" item-text="name" item-value="id" label="Room No." outlined persistent-hint hint="Please Select Room No." />
                </v-col>
                <v-col cols="12" sm="4" md="4">
                    <p><v-icon color="error">*</v-icon><b>Incharge Faculty</b></p>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="inst" :items="inst_list" item-text="name" item-value="id" label="Incharge Faculty" outlined persistent-hint hint="Please Select Incharge Faculty" />
                </v-col>
                <v-col cols="12" sm="8" md="8">
                    <p><v-icon color="error">*</v-icon><b>Description</b></p>
                    <v-textarea outlined name="input-7-4" v-model="description" label="Enter Description"></v-textarea>
                </v-col>
                <v-col cols="12" sm="6" md="6" >
                 <v-simple-table  v-if="mtype" dense class="elevation-1 mytable">
                     <thead>
                        <tr>
                            <th>Material Part</th>
                            <th>Purchase Cost Including Tax Per Item</th>
                        </tr>
                     </thead>
                     <tbody>
                        <tr v-for="p,index in part_list" :key="index">
                        <td>{{p.name}}</td>
                        <td>
                              <input class="input text-center" type="number" @change="calCompTotal" v-model="p.cost" name="p.id" :rules="[(v) => !!v || 'Required' || v >= 0]" />               
                        </td>
                        </tr>
                        <tr>
                            <td colspan="2">
                              <strong>  Total Purchase Cost Including Tax Per Item </strong>
                                <input class="input text-center" type="number" v-model="total_amt" :rules="[(v) => !!v || 'Required' || v >= 0]" />               
                            </td>
                        </tr>
                     </tbody>
                 </v-simple-table>
                </v-col>
                 <v-col v-if="invoice && ay && org && room && inst && description && mspec && mtype" cols="12" sm="6" md="6">
                    <v-btn class="button" @click="save()">Save</v-btn>
                </v-col>
            </v-row>
        </v-card>
    </div>
</template>
<script>
    import axios from "axios";
    export default {
        data: () => ({
            dialog_delete: false,
            awspath: null,
            add_new: false,
            edit_invoice: false,
            valid: false,
            overlay: false,
            snackbar_msg: "",
            color: "",
            snackbar: false,
            search: "",
            material_type_list: [],
            invoice_list: [],
            invoice: null,
            inventory_vendor_list: [],
            ay_list: [],
            inst_list: [],
            room_list: [],
            org_list: [],
            add_new: false,
            org: null,
            ay: null,
            room: null,
            inst: null,
            mtype: null,
            material_specification: [],
            mspec: null,
            part_list: [],
            description: null,
            total_amt:0,
        }),
        watch: {
            dialog(val) {
                val || this.close();
            },
            overlay(val) {
                val = () => {
                    this.overlay = false;
                };
            },
        },
        mounted() {
            this.awspath = localStorage.getItem("awspath");
            this.onLoad();
        },
        methods: {
            async save() {
                 const data = {
                    invoice:this.invoice.id,
                    ay:this.ay,
                    org:this.org,
                    room:this.room,
                    inst:this.inst,
                    description:this.description,
                    mspec:this.mspec,
                    mtype:this.mtype.id,
                    total_amt:this.total_amt,
                    part_list:this.part_list,
                    invoice:this.invoice.invoice_id,
                };
                this.overlay = true;
                try {
                    const res = await axios.post("/InventoryAccountOfficer/saveInventory", data);
                    if (res.data.flag == "YES") {
                        this.showSnackbar("green", "Saved Successfully..");
                       
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                    this.overlay = false;
                } catch (err) {
                    console.log("err", err);
                    this.onerror(err);
                    this.overlay = false;
                } finally {
                    this.overlay = false;
                   // this.markAllSelected();
                }
            },
        onerror(error) {
                let msg = "";
                if (error.response) {
                    msg = "Something went wrong.";
                } else if (error.request) {
                    msg = "Please try again.";
                } else {
                    msg = "Un-expected error.";
                }
                this.showSnackbar("error", msg);
            },
        calCompTotal(){
                for (var i = 0; i < this.part_list.length; i++) {
                    this.total_amt += parseFloat(this.part_list[i].cost);
                }
        },
            getPart_Specification() {
                this.material_specification = [];
                this.part_list = [];
                this.material_specification = this.mtype.material_specification;
                this.part_list = this.mtype.part_list;
            },
            onLoad() {
                axios
                    .post("InventoryAccountOfficer/getDataAddInventory")
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.material_type_list = res.data.material_type_list;
                            this.invoice_list = res.data.invoice_list;
                            this.inventory_vendor_list = res.data.inventory_vendor_list;
                            this.ay_list = res.data.ay_list;
                            this.inst_list = res.data.inst_list;
                            this.room_list = res.data.room_list;
                            this.org_list = res.data.org_list;
                            this.overlay = false;
                        } else {
                            this.showSnackbar("#b71c1c", res.data.status_reason);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        this.overlay = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },
    };
</script>
<style scoped>
 input[type="number"] {
        width: 50%;
        display: inline-block;
        border: 1px solid black;
        border-radius: 4px;
        box-sizing: border-box;
    }
    .v-text-field {
        padding-top: 0px;
        margin-top: 0px;
    }
    .v-icon-size {
        font-size: 20px;
    }
    .edit-avatar {
        transition: 0.3s;
        border: 1px solid #b0bec5;
    }
    .edit-avatar:hover {
        background-color: #b0bec5;
    }
    .edit-v-icon {
        padding-left: 6px;
        font-size: 15px;
    }
    .edit-v-icon:hover {
        color: white;
    }
   thead {
        font-weight: bold !important;
    }
    th {
        font-weight: bold !important;
    }
    tr,
    td,
    th {
        border: 1px solid black;
        /* text-align: center; */
        font-size: small;
    }
    tr,
    tbody {
        border-bottom: 1px solid black;
        border: 1px solid black;
        font-size: small;
    }
    td {
        font-size: small;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
            font-size: small;
        }
        td + td,
        th + th {
            width: auto;
            font-size: small;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        /* text-align: center; */
        font-size: small;
    }
</style>
